// extracted by mini-css-extract-plugin
export default {"productGallery":"EK-z","inQuickShop":"FK-z"};